<template>
<div class="odr-linear-progress">
    <div class="odr-linear-progress__bar"/>
</div>
</template>

<script>
import '@/scss/blocks/linear-progress.scss';

export default {};
</script>
